import * as React from 'react';
import { useSelector } from 'react-redux';

import { Approval } from '../../components/Approval';
import { selectAgentLevelInfo } from '../../selectors';
import { selectAgent } from '../../selectors/selectAgent';
import { getAgentType } from '../../utils/getAgentType';
import { getProofMessage } from '../../utils/getProofMessage';
import { selectHasVerifiedDocuments } from './selectors/selectHasVerifiedDocuments';

export const ApprovalContainer = () => {
  const agent = useSelector(selectAgent);
  const agentLevelInfo = useSelector(selectAgentLevelInfo);
  const hasVerifiedDocuments = useSelector(selectHasVerifiedDocuments);
  const agentType = React.useMemo(() => agent && getAgentType(agent), [agent]);
  const message = React.useMemo(() => agentType && getProofMessage(agentType), [agentType]);

  if (agentLevelInfo || !hasVerifiedDocuments || !message) {
    return null;
  }

  return <Approval message={message} />;
};
